@if (status.active()) {
  <div class="bypass-active-banner">
    <app-icon class="bypass-active-banner__icon" name="triangle-alert" [size]="18" aria-hidden="true" />
    <p class="bypass-active-banner__message" role="alert">
      Bypass de emergencia ACTIVO: las solicitudes se registran en SB sin evaluar BCRA/reglas.
    </p>
  </div>
}
